module.exports = __webpack_public_path__ + "media/images/athletes/3557-5b5408efd4244438a5e47e37afbacb0d.png";